export default __webpack_public_path__ + "static/media/ic-img.dd02fee9.svg";